import { PageShell } from './PageShell.js';
import { Pricing } from '../sections/Pricing.js';
import { PricingStructuredData } from '../components/PricingStructuredData.js';
import type { WashedLocale } from '@washed/i18n';

interface PageProps {
  locale: WashedLocale;
  onLocaleChange: (locale: WashedLocale) => void;
}

// The Pricing section supplies the visible pricing headline; this is the
// screen-reader/SEO <h1> only, so it stays a distinct topical phrase.
const TITLE: Record<WashedLocale, string> = {
  fr: 'Tarifs Washed — 6 formules et prix mensuels à Lomé',
  en: 'Washed pricing — 6 monthly plans in Lomé',
};

export function PricingPage({ locale, onLocaleChange }: PageProps) {
  return (
    <PageShell
      locale={locale}
      onLocaleChange={onLocaleChange}
      title={TITLE[locale]}
      heroHeader={false}
      cta={false}
    >
      <PricingStructuredData locale={locale} />
      <Pricing locale={locale} />
    </PageShell>
  );
}
